import { AllocationSkillId } from "@/types/allocations";

export const ALLOCATION_SKILLS = {
  19: "Digital",
  20: "Callback",
  21: "Lead Gen",
  42: "Customer Order",
  49: "Customer Order VDP",
  53: "Powered By Allocations",
} as const;

export const SKILL_IDS = Object.keys(ALLOCATION_SKILLS).map(Number) as AllocationSkillId[];

export const ALLOCATION_SKILL_TYPES: Record<number, string> = {
  1: "Lenders",
  2: "Lenders",
  3: "Lenders",
  4: "Vehicles",
  5: "Lenders",
  6: "Allocation",
  7: "Balance",
  8: "Balance",
  9: "Finance",
  10: "Partners",
};
